
const SPINNER_SWEEP = Math.PI * 2 * 0.75;
const RING_SIZE = 100;
const RING_STROKE = 7;
const RING_RADIUS = (RING_SIZE - RING_STROKE) / 2;
// const WALLET_CREATION_DURATION_MS = 4000;

const polarToCartesian = (cx, cy, radius, angle) => ({
  x: cx + radius * Math.cos(angle),
  y: cy + radius * Math.sin(angle),
});

const describeArc = (cx, cy, radius, startAngle, sweepAngle) => {
  const start = polarToCartesian(cx, cy, radius, startAngle);
  const end = polarToCartesian(cx, cy, radius, startAngle + sweepAngle);
  const largeArcFlag = sweepAngle > Math.PI ? 1 : 0;

  return `M ${start.x} ${start.y} A ${radius} ${radius} 0 ${largeArcFlag} 1 ${end.x} ${end.y}`;
};

const GradientSpinnerRing = ({ gradientId }) => {
  const center = RING_SIZE / 2;
  const startAngle = Math.PI / 2;
  const start = polarToCartesian(center, center, RING_RADIUS, startAngle);
  const end = polarToCartesian(center, center, RING_RADIUS, startAngle + SPINNER_SWEEP);
  const arcPath = describeArc(center, center, RING_RADIUS, startAngle, SPINNER_SWEEP);

  return (
    <div
      // className="absolute inset-0 animate-spin"
      className="inset-0 animate-spin"
      style={{ animationDuration: "1.4s" }}
      aria-hidden
    >
      <svg
        width={RING_SIZE}
        height={RING_SIZE}
        viewBox={`0 0 ${RING_SIZE} ${RING_SIZE}`}
      >
        <defs>
          <linearGradient
            id={gradientId}
            gradientUnits="userSpaceOnUse"
            x1={start.x}
            y1={start.y}
            x2={end.x}
            y2={end.y}
          >
            <stop offset="0%" stopColor="#4ab932" stopOpacity="0.06" />
            <stop offset="65%" stopColor="#4ab932" stopOpacity="0.35" />
            <stop offset="100%" stopColor="#4ab932" stopOpacity="1" />
          </linearGradient>
        </defs>
        <path
          d={arcPath}
          fill="none"
          stroke={`url(#${gradientId})`}
          strokeWidth={RING_STROKE}
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};

export default GradientSpinnerRing;